import { gql } from '@apollo/client';

export const GET_CHANGE_LOGS = gql`
  query GetChangeLogs(
    $entityId: String!
    $systemName: String!
    $changedFields: [String!]
  ) {
    changeLogs(
      entityId: $entityId
      systemName: $systemName
      changedFields: $changedFields
    ) {
      changeId
      changedByEmail
      changedFields
      createdAt
      entityId
      newData
      previousData
      systemName
    }
  }
`;

export const GET_LIVERAMP_INTEGRATIONS = gql`
  query GetLiveRampIntegrations(
    $distributionManagerId: String
    $distributionManagerName: String
    $integrationId: String
    $integrationName: String
  ) {
    liveRampIntegrations(
      distributionManagerId: $distributionManagerId
      distributionManagerName: $distributionManagerName
      integrationId: $integrationId
      integrationName: $integrationName
    ) {
      integrations {
        integrationId
        integrationName
      }
      distributionManagers {
        distributionManagerId
        distributionManagerName
        integrationId
        integrationName
      }
    }
  }
`;

export const GET_AUDIENCE_EXPORT_HISTORY = gql`
  query GetAudienceExportHistory($audienceIds: [String!]!) {
    audienceExportHistory(audienceIds: $audienceIds) {
      # Core identifiers
      export_id
      audience_id
      request_id
      audience_name

      # Export details
      export_by
      export_type
      system_used
      file_name
      segment_name
      description

      # Financial metrics
      cpm
      percent_of_media
      tv_cpm

      # Platform details
      advertiser_id
      publisher_id
      platform_integrated
      platform_destination
      advertiser_destination
      receiver_email

      # Timestamps
      created_at
      timestamp_status_export_started
      timestamp_status_email_sent

      # Status flags
      status_export_started
      status_email_sent
      is_seed_operation_success
      is_export_operation_success

      # User counts
      seeded_users_count
      exported_users_count

      # LAL model details
      lal_model_id
      lal_model_type
      lal_model_precision
      lal_model_precision_users_count

      # Meta LAL ratio
      meta_lal_ratio

      # TikTok Custom Segment fields
      placements
      mobile_os
      audience_modeling_breadth

      # Additional fields from audience_export_state view
      segment_id
      platform_users_count
      platform_users_count_active_ids
      timestamp_platform_users
      uid2_users_count
      lookalike_users_count
      status_sent_to_transunion
      timestamp_status_sent_to_transunion
      status_received_from_transunion
      timestamp_status_received_from_transunion

      # Platform Segment Creation (Production)
      status_platform_segment_created

      # Computed/derived fields
      export_status

      # Error details - JSON scalar that can contain any structure
      error
    }
  }
`;

export const GET_TTD_OTS_SEGMENTS = gql`
  query GetTtdOtsSegments(
    $sortBy: String
    $sortOrder: String
    $search: String
    $platform: String
    $rateLevel: String
    $page: Int
    $recordPerPage: Int
  ) {
    ttdOtsSegments(
      sortBy: $sortBy
      sortOrder: $sortOrder
      search: $search
      platform: $platform
      rateLevel: $rateLevel
      page: $page
      recordPerPage: $recordPerPage
    ) {
      lastSyncAt
      totalRecords
      segments {
        id
        segmentName
        receivedIds
        activeIds
        cpm
        pom
        impressions
        effectiveCpm
        revenue
        lastUpdatedAt
        rateLevel
        partnerId
        advertiserId
      }
    }
  }
`;

export const GET_TTD_OTS_SEGMENT_DETAIL_BY_ID = gql`
  query GetTtdOtsSegmentDetailById(
    $segmentId: String!
    $rateLevel: String
    $advertiserId: String
    $partnerId: String
  ) {
    ttdOtsSegmentDetailById(
      segmentId: $segmentId
      rateLevel: $rateLevel
      advertiserId: $advertiserId
      partnerId: $partnerId
    ) {
      id
      segmentName
      description
      cpm
      pom
      effectiveCpm
      totalRevenue
      totalImpressions
      revenueThisMonth
      impressionsThisMonth
      month
      lastUpdatedAt
      rateLevel
      partnerId
      advertiserId
    }
  }
`;

export const GET_TTD_OTS_SEGMENT_METRICS = gql`
  query GetTtdOtsSegmentMetrics(
    $segmentId: String!
    $rateLevel: String
    $advertiserId: String
    $partnerId: String
    $periodType: String!
  ) {
    ttdOtsSegmentMetrics(
      segmentId: $segmentId
      rateLevel: $rateLevel
      advertiserId: $advertiserId
      partnerId: $partnerId
      periodType: $periodType
    ) {
      periodType
      periods
      data {
        period
        activeIds {
          value
          label
        }
        revenue {
          value
          label
        }
        receivedIds {
          value
          label
        }
        impressions {
          value
          label
        }
        cpm {
          value
          label
        }
        ecpm {
          value
          label
        }
      }
    }
  }
`;
